//#region Old Code
// import * as React from "react";
// import LinkComp from "../LinkComp";
// import Icon from "../Icon";
// import Alert from "../Alert";
// import Tabs from "../Tabs";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import ConfirmationDialog  from "../ConfirmDialog";
// import "./CRUD.scss";


// const CRUD = ({userData, isSeniorAgent, isSuper, originalData, router, tabsData, currentPageRef = null, drawer = null, backLink, edit, children = null, state, setState, handleSubmit, extraHeaderInfo, extraInfo = null, type = "", backName = "", isAgent = false, saveData, title = "", formattedOriginalData = null, formattedLoanQuotesOriginalData = null, formattedPaymentsOriginalData = null, tabsClass = '',}) => {
//     const {data, viewMode, success, error, errorTabs, currentTab, showConfirm=false, isExists=false} = state;
// debugger
//     const handleCancel = () => {
//         if (!viewMode) {
//             if (formattedLoanQuotesOriginalData && formattedPaymentsOriginalData) {
//                 setState((prevState) => ({
//                     viewMode: true,
//                     data: formattedOriginalData
//                         ? {...formattedOriginalData}
//                         : {...prevState.original},
//                     [formattedLoanQuotesOriginalData.name]:formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name],
//                     [formattedPaymentsOriginalData.name]:formattedPaymentsOriginalData.data? formattedPaymentsOriginalData.data : prevState[formattedPaymentsOriginalData.name]
//                 }));
//             } else {
//                 setState((prevState) => ({
//                     viewMode: true,
//                     data: formattedOriginalData
//                         ? {...formattedOriginalData}
//                         : {...prevState.original},
//                 }));
//             }
//         }
//         else if(!data.DELETED){
//             setState({showConfirm:true})
//         }
//         else toggleDelete();
//     }

//     const onCloseConfirm= (val)=>{
//         if(val){
//             toggleDelete();
//         }
//         setState({showConfirm:false})
//     }

//     React.useEffect(() => {
//         if (originalData) {
//             const logginedUserName = userData.person.firstName + " "+ userData.person.lastName;
//             for (let i = 1; i <= 4; i++) {
//                 const name = (originalData['LISTING_AGENT_' + i + '_FIRST_NAME'] || "") + ' ' + (originalData['LISTING_AGENT_' + i + '_LAST_NAME'] || "");
//                 if ((isSeniorAgent && (!data.LISTING_AGENT_1 || !data.LISTING_AGENT_2 )) || (isSeniorAgent && name && logginedUserName.toLowerCase()=== name.toLowerCase())) {
//                     setState({ isExists: true });
//                 }
//             }
//         }
//     }, [originalData])
//     const toggleDelete = () => {
//         if (!data.DELETED) {
//             data.DELETED = "1";
//             setState({data}, saveData);
//         } else {
//             data.DELETED = null;
//             setState({data}, saveData);
//         }
//     };

//     if (data === null) {
//         return <div>Loading...</div>;
//     } else if (data === false) {
//         return (
//             <Alert type="warn">
//                 {`${type.charAt(0).toUpperCase()}${type.slice(1)} not found`}
//             </Alert>
//         );
//     } else {
//         return (
//             <div className="CRUD" ref={currentPageRef}>
//                 {drawer}
//                 <div className="CRUD_content">
//                     <div className="page-rounded-corner-container">
//                         <div className="page-header-container list">
//                             <div className="page-back-button" onClick={() => {history.back()}}>
//                                 <Icon svg={svgSortAsc}/>
//                                 {backName}
//                             </div>
//                             <ConfirmationDialog open={showConfirm}  onClose={onCloseConfirm}/>
//                             <div className="page-header">
//                                 <div className="page-title">{edit ? title : "Add " + type}</div>
//                                 {((isAgent || isSuper || data.SOURCE=='External') || (isExists && data.SOURCE=="STRIVE" && (data.STATUS=="Proposal" || data.STATUS=="Property Info" ))) && <div> {edit ? (
//                                     <button className="button-new negative margin-left"
//                                             onClick={handleCancel}
//                                     >
//                                         {viewMode && (data.ARCIMEDES_ROW_ID || data.arcimedes_row_id)
//                                             ? data && (data.DELETED === "1" || data.deleted === "1")
//                                                 ? "Undelete"
//                                                 : "Delete"
//                                             : "Cancel"}
//                                     </button>
//                                 ) : (
//                                     <LinkComp to={backLink}>
//                                         <button className="button-new negative margin-left">Cancel</button>
//                                     </LinkComp>
//                                 )}
//                                 <button
//                                     form={`${type}-form`}
//                                     type="submit"
//                                     disabled={isAgent || data.DELETED === "1" || (!edit && isSeniorAgent && ((data.SOURCE == 'External' && !(data.STATUS == 'Active' || data.STATUS == 'Closed')) || (data.SOURCE == 'STRIVE' && ! (data.STATUS == 'Proposal'))))}
//                                     className={`button-new positive  margin-left ${
//                                         data.DELETED === "1" ? "inactive" : ""
//                                     }`}
//                                 >
//                                     {edit ? (viewMode ? "Edit" : "Save") : "Add"}
//                                 </button> </div> }
//                                 {extraHeaderInfo}
//                             </div>
//                         </div>
//                     </div>
//                     <div className={`page-body-container crud ${type === 'property' ? 'property' : ''}`}>
//                         {success ? <Alert type="success">{success}</Alert> : null}
//                         {error ? <Alert type="error">{error}</Alert> : null}
//                         {errorTabs.length > 0 && currentTab !== 0 ? (
//                             <Alert type="error">
//                                 Unable to add {type} because you have an empty mandatory field
//                                 on another tab.
//                             </Alert>
//                         ) : null}

//                         <form onSubmit={handleSubmit} id={`${type}-form`} className={`form-container ${isAgent ? 'isAgent' : ''}`}>
//                             <Tabs
//                                 onChangeTab={(tab) => {                                  
//                                     if(tabsData[tab].name.indexOf("PROPERTY")>=0 && tabsData[tab].renderedComponent && tabsData[tab].renderedComponent.props.data && tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID){
//                                         router.push("/property/"+tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID);                                        
//                                     }
//                                     setState({currentTab: tab})}
//                                 }
//                                 errorTabs={errorTabs}
//                                 tabsData={tabsData}
//                                 className={tabsClass}
                               
//                             />
//                         </form>

//                         {extraInfo &&
//                             <div className='CRUD_content_extra_info'>
//                                 <div className='line'/>
//                                 {extraInfo}
//                             </div>
//                         }
//                     </div>
//                 </div>
//                 {children}
//             </div>
//         );
//     }
// };

// export default CRUD;

//#endregion








import * as React from "react";
import LinkComp from "../LinkComp";
import Icon from "../Icon";
import Alert from "../Alert";
import Tabs from "../Tabs";
import svgSortAsc from "../../svgs/arrow-up.svg";
import ConfirmationDialog from "../ConfirmDialog";
import "./CRUD.scss";
import EmailPopover from "../ReactTable/EmailPopover";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ReusableSpinner from '../ReactTable/ReusableSpinner';
import filter from "../../filter";
import { removeDuplicateObjects, compareDates,getCurrentTrancheOnGrossAmount, isAgentUser} from "../../utils";
import { GET_HOTLIST_PROPERTIES_BY_EMAIL } from "../Graphql/Queries/HotList";
import { UserContext } from "../Root/Root";
import { GET_AGENT_COMMISSION_PAID, GET_AGENT_COMMISSION_PROCURED } from "../Graphql/Queries/agentCommissionBreakdown";
import { fetchData } from "../Service/graphQlService";
import { browserHistory } from "react-router";
import cloneDeep from "lodash.clonedeep";
const CRUD = ({ userData, isSeniorAgent, isSuper, originalData, router, tabsData, currentPageRef = null, drawer = null, backLink, edit, children = null, state, setState, handleSubmit, extraHeaderInfo, extraInfo = null, type = "", backName = "", isAgent = false, saveData, title = "", formattedOriginalData = null, formattedLoanQuotesOriginalData = null, formattedPaymentsOriginalData = null, tabsClass = '',updateURL,backToUrl }) => {
    const { data, viewMode, success, error, errorTabs, currentTab, showConfirm = false, isExists = false, filterData = [], currentIndex = 0 } = state;
    const [openEmailPopup,setOpenEmailPopup] = React.useState(false)
const user = React.useContext(UserContext);
const userLoginEmail = user && user.userData && user.userData.email ? user.userData.email : null;
 const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
 const isAgentRestrictedUser  =  isAgentUser(storedUserData)
const crmBack = sessionStorage.getItem("isCrmback");
const isOriginalDataEmpty =
  type === "property"
    ? !originalData || typeof originalData !== "object" || Object.keys(originalData || {}).length === 0
    : false; 
let newPath = "";
let path = "";

if (crmBack) {
  [newPath, path] = crmBack.split("|");
}
    const handleCancel = async () => {
        if (!viewMode) {
            if (formattedLoanQuotesOriginalData && formattedPaymentsOriginalData) {  
                setState((prevState) => {
                    const newData = formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original };
                    newData[formattedLoanQuotesOriginalData.name] = formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name];
                    newData[formattedPaymentsOriginalData.name] = formattedPaymentsOriginalData.data ? formattedPaymentsOriginalData.data : prevState[formattedPaymentsOriginalData.name];
                    return {
                        viewMode: true,
                        data: newData,
                        loanQuotesData: newData[formattedLoanQuotesOriginalData.name]
                    };
                });
                if (formattedOriginalData) {
                    await handleHotListCheckboxChange(formattedOriginalData);
                    if(formattedOriginalData.transaction_type === 'Extra Payment'){
                        await fetchNetFeeValue(formattedOriginalData);
                    }
                }
            }else if (formattedLoanQuotesOriginalData) {
                setState((prevState) => {
                    const newData = formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original };
                    newData[formattedLoanQuotesOriginalData.name] = formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name];
                    return {
                        viewMode: true,
                        data: newData,
                        loanQuotesData: newData[formattedLoanQuotesOriginalData.name]
                    };
                });
                if (formattedOriginalData) {
                    await handleHotListCheckboxChange(formattedOriginalData);
                    if(formattedOriginalData.transaction_type === 'Extra Payment'){
                        await fetchNetFeeValue(formattedOriginalData);
                    }
                }
            }else if(title === 'Proposals'){
                setState((prevState) => {
                    const newData = [...prevState.original];
    
                    return {
                        viewMode: true,
                        data: newData,
                        removedCards:[]
                    };
                });
            }  else {
                setState((prevState) => {
                  let newData = {
                    viewMode: true,
                    data: formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original },
                  }
                  if(prevState.originalTerritories){
                    newData = {...newData,territory:cloneDeep(prevState.originalTerritories)}
                  }
                  return newData
                });
                // formattedOriginalData is null for records without property/loan
                // data (e.g. investors), so guard before dereferencing it.
                if (formattedOriginalData) {
                    await handleHotListCheckboxChange(formattedOriginalData);
                    if(formattedOriginalData.transaction_type === 'Extra Payment'){
                        await fetchNetFeeValue(formattedOriginalData);
                    }
                }
            }
        }else if(title === 'Proposals'){
            return;
        }
        else if (!data.deleted) {
            setState({ showConfirm: true })
        }
        else toggleDelete();
        console.log(data)
    }

       const handleHotListCheckboxChange = async (originalData) => {
        const data = {...originalData};
        Promise.all([
          fetchData(GET_HOTLIST_PROPERTIES_BY_EMAIL, { email_id: userLoginEmail})
            // executeQuery({
            //     queryName: HOTLIST_PROPERTIES_BY_EMAIL,
            //     params: {
            //         EMAIL_ID : userData.email,
            //     },
            // }),
        ]).then((res) => {
            if (res && res[0] && res[0].data.hotlistPropertiesByEmail.success && res[0].data.hotlistPropertiesByEmail.data.length) {
                let hotListProperties = res[0].data.hotlistPropertiesByEmail.data[0];
              
                // let propertiesArray = hotListProperties;
                if (hotListProperties.arcimedes_row_id === data.arcimedes_row_id) {
                    setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            hot_list: true
                        },
                    }));
                } else {
                    setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            hot_list: false
                        },
                    }));
                }
            }            
        });    
    };

    

    const fetchNetFeeValue = async (originalData) => {
        try {
        const data = {...originalData};
        const date = new Date(data && data.close_of_escrow);
        const year = date.getFullYear();
        const id = data && data.listing_agent_1;
        const feeAmount = data && data.referral_fee;
              
        if(feeAmount && year != 1970 && id){
            let q = {
                AGENT_ID: id,
                YEAR: year,
                order:'CLOSE_OF_ESCROW.asc'
            }       
            const options = filter(q, 'agent-commission');  
            
             const optionsYear = parseInt(options.param.YEAR);
            const optionsAgentId = parseInt(options.param.AGENT_ID);        
            Promise.all([
                  fetchData(GET_AGENT_COMMISSION_PROCURED,{year: optionsYear, agentId: optionsAgentId}),
                               fetchData(GET_AGENT_COMMISSION_PAID,{options:{year: optionsYear, agent_id: optionsAgentId}}),
                // executeQuery({queryName: AGENT_COMMISSION_PROCURED, options}),
                // executeQuery({queryName: AGENT_COMMISSION_PAID, options})
            ]).then(res => {
                if (res && res[0] && res[0].data && Array.isArray(res[0].data.agentCommissionProcured) &&
                res[1] && res[1].data && Array.isArray(res[1].data.agentCommissionPaid)){                
                    let grossCumulative = 0;                  
                    let currentTrenche = 0;
                    let insertionIndex = 0; 
                    let paidData = removeDuplicateObjects(res[1].data.agentCommissionPaid.filter(property => property.member_id === id));
                    let map = new Map();
                    res[0].data.agentCommissionProcured.forEach(item =>{ 
                        map.set(item.arcimedes_row_id, item)
                    });
                    // paidData.forEach(item => {
                    //     if (map.has(item.arcimedes_row_id)) {
                    //         let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                    //         map.set(item.arcimedes_row_id, {...map.get(item.arcimedes_row_id), TEAM_MEMBER_GROSS_FEE});
                    //     } else {
                    //         map.set(item.arcimedes_row_id, item);
                    //     }
                    // });
                     paidData.forEach(item => {
                        if (map.has(item.arcimedes_row_id)) {
                            let team_member_gross_fee = item.team_member_gross_fee;
                            map.set(item.arcimedes_row_id, {...map.get(item.arcimedes_row_id), team_member_gross_fee});
                        } else {
                            map.set(item.arcimedes_row_id, item);
                        }
                    });
                    const mergedArray =  Array.from(map.values());  
                    mergedArray.sort(compareDates);
                    const newCloseDate = new Date(data.close_of_escrow);
                    const index = mergedArray.findIndex(item => new Date(item.close_of_escrow) > newCloseDate);
                    if (index === -1) {
                        insertionIndex = mergedArray.length-1;                        
                    } else {
                        insertionIndex = index-1;
                    }
                    mergedArray.forEach((agentObj,index) => {
                    const listingProcuredGrossFee = agentObj.listing_gross_commission ? parseFloat(agentObj.listing_gross_commission) : 0;
                    const buyingProcuredGrossFee = agentObj.buying_gross_commission ? parseFloat(agentObj.buying_gross_commission) : 0;
                    const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;                       
                    grossCumulative += totalProcuredGrossFee; 
                    if(insertionIndex === index)  {
                        currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)                        
                        return;
                    }    
                });                    
                setState((prevState) => ({
                    data: {
                        ...prevState.data,
                        net_fee: data.transaction_type === 'Extra Payment' ? ((parseFloat(feeAmount.replace(/,/g, '')) * currentTrenche)).toFixed(2) : ''
                    },
                }));
            }              
            });    
        }
            
        } catch (error) {
            console.error('Failed to fetch net_fee:', error);
            return ''; // Return empty or fallback value if the query fails
        }
    };

    const onCloseConfirm = (val) => {
        if (val) {
            toggleDelete();
        }
        setState({ showConfirm: false })
    }

    React.useEffect(() => {
        if (originalData) {
            const logginedUserName = userData.username;
            for (let i = 1; i <= 4; i++) {
                const name = (originalData['listing_agent_' + i + '_first_name'] || "") + ' ' + (originalData['listing_agent_' + i + '_last_name'] || "");
                if ((isSeniorAgent && (!data.listing_agent_1 || !data.listing_agent_2)) || (isSeniorAgent && name && logginedUserName.toLowerCase() === name.toLowerCase())) {
                    setState({ isExists: true });
                }
            }
        }
    }, [originalData])
    

    const toggleDelete = () => {
        const newData = { ...data };
    
        // Toggle between deleted and undeleted
        newData.deleted = newData.deleted === 1 ? null : 1;
    
        setState({ data: newData }, saveData);
    };

    // const nextRecord = () => {
    //   setState((prevState) => {
    //     if (prevState.currentIndex < prevState.filterData.length - 1) {
    //       return {
    //         currentIndex: prevState.currentIndex + 1,
    //         data: prevState.filterData[prevState.currentIndex + 1],
    //       };
    //     }
    //     return prevState;
    //   });
    // };
    
    // const prevRecord = () => {
    //   setState((prevState) => {
    //     if (prevState.currentIndex > 0) {
    //       return {
    //         currentIndex: prevState.currentIndex - 1,
    //         data: prevState.filterData[prevState.currentIndex - 1],
    //       };
    //     }
    //     return prevState;
    //   });
    // };
    const nextRecord = () => {
      setState((prevState) => {
        if (prevState.currentIndex < prevState.filterData.length - 1) {
          const newIndex = prevState.currentIndex + 1;
          const newData = prevState.filterData[newIndex];
          updateURL(newData); // Update the URL from CRUDFirm.js, related things i added in CRUDFirm.js
          return { currentIndex: newIndex, data: newData };
        }
        return prevState;
      });
    };
  
    const prevRecord = () => {
      setState((prevState) => {
        if (prevState.currentIndex > 0) {
          const newIndex = prevState.currentIndex - 1;
          const newData = prevState.filterData[newIndex];
          updateURL(newData);
          return { currentIndex: newIndex, data: newData };
        }
        return prevState;
      });
    };
    
    if (data === null) {
        return <ReusableSpinner />
    } else if (data === false) {
        return (
            <Alert type="warn">
                {`${type.charAt(0).toUpperCase()}${type.slice(1)} not found`}
            </Alert>
        );
    } else {
        return (
          <div className="CRUD" ref={currentPageRef}>
            {drawer}
            <div className="CRUD_content">
              <div className="page-rounded-corner-container">
                <div className="page-header-container list">
                  {/* <div
                    className="page-back-button"
                    onClick={() => {
                      history.back();
                    }}
                  >
                    <Icon svg={svgSortAsc} />
                    {backName}
                  </div> */}
                  <div style={{ display: 'flex', alignItems: 'center', width: '80%' }}>
                    {backName && <div
                      className="page-back-button"
                      onClick={() => {
                        sessionStorage.removeItem("companyData");
                        const teamMembersEmail = [
                          "gholley@highstcapital.com",
                          "jarnold@highstcapital.com",
                          "gholley@highstcapital.com,jarnold@highstcapital.com",
                          "mkeeler@athenacapitalre.com"
                        ];

                        const staticPaths = [
                          "/pipeline/in-negotiation",
                          "/pipeline/active",
                          "/pipeline/under-contract",
                          "/pipeline/total-neg-uc",
                          "/pipeline/other-neg-uc",
                          "/pipeline/closed-ytd",
                          "/pipeline/closed-ytd-other",
                          "/pipeline/total-closed-ytd",
                        
                        ];

                        const listStatuses = [
                          "Courting",
                          "Loan%20In%20Process",
                        ];
                      const generateClosedPaths = (startYear, endYear) => {
                        const years = [];
                        for (let year = endYear; year >= startYear; year--) {
                          years.push(`closed-${year}`);
                        }
                        return ["closed-ytd","total-closed", ...years];
                      };

                      const hscPipelinePaths = generateClosedPaths(
                        2018,
                        new Date().getFullYear()
                      );


                     const listPaths = listStatuses.flatMap((status) => [
                       `/list?hsc_status=${status}&source=HSC`, // ✅ no team members
                       ...teamMembersEmail.map(
                         (m) =>
                           `/list?hsc_status=${status}&source=HSC&hsc_team_members=${m}`
                       ),
                     ]);

                        const pipelinePaths = hscPipelinePaths.flatMap((p) =>
                          teamMembersEmail.map(
                            (m) => `/hsc-pipeline/${p}?HSC_TEAM_MEMBERS=${m}`
                          )
                        );
                       const generateClosedYearPathsNoTeam = (
                         startYear,
                         endYear
                       ) => {
                         const yearPaths = Array.from(
                           { length: endYear - startYear + 1 },
                           (_, i) => {
                             const year = endYear - i;
                             return `/hsc-pipeline/closed-${year}`;
                           }
                         );

                         return [
                           "/hsc-pipeline/total-closed", // ✅ added here
                           ...yearPaths,
                         ];
                       };
                        const closedNoTeamPaths = generateClosedYearPathsNoTeam(2018, new Date().getFullYear());
                        const ignorePathToAvoidIssue = [
                          ...staticPaths,
                          ...listPaths,
                          ...pipelinePaths,
                          ...closedNoTeamPaths
                        ];
                        if (ignorePathToAvoidIssue.some(path => backToUrl.includes(path))) {
                          history.back();
                        }
                        if(newPath){
                         const baseUrl = location.origin;
                         const pathMap = {
                           agent: "contacts/agents",
                           vendor: "contacts/vendors",
                           lender: "contacts/lenders",
                           tenant: "contacts/tenants",
                           teamMember: "contacts/team-members",
                           investor: "contacts/investors",
                           property:"list?source=STRIVE&status=Active&transaction_type=Investment+Sales",
                           users :"userList"
                         };
                         const url = `${baseUrl}/${pathMap[newPath]}`;
                          browserHistory.push(url)
                        }
                     else{
                      const baseUrl = location.origin;
                      const url = `${baseUrl}${backToUrl}`;
                      browserHistory.push(url);
                     }
                     sessionStorage.removeItem("isCrmback");
                      }}
                      disabled={isAgentRestrictedUser}
                      style={{ display: 'flex', alignItems: 'center' ,opacity: isAgentRestrictedUser  ? 0.5 : 1,}}
                    >
                      <Icon svg={svgSortAsc} />
                      {backName}
                    </div>}
                    {state.searchCrudFilter && (
                      <div style={{ display: 'flex', gap: '25px', marginLeft: 'auto', color: 'rgb(144, 197, 75)', marginTop:'-10px' }}>
                        <ArrowBackIosIcon
                          style={{ cursor: state.currentIndex === 0 ? 'not-allowed' : 'pointer' }}
                          disabled={currentIndex === 0}
                          onClick={prevRecord}
                        />
                        <ArrowForwardIosIcon
                          style={{ cursor: state.currentIndex === state.filterData.length - 1 ? 'not-allowed' : 'pointer' }}
                          disabled={currentIndex === filterData.length - 1}
                          onClick={nextRecord}
                        />
                      </div>
                    )}
                  </div>
                  <ConfirmationDialog
                    open={showConfirm}
                    onClose={onCloseConfirm}
                  />
                  <div className="page-header">
                    <div className="page-title">
                      {edit ? title : "Add " + (type === "vendor" ? "Vendors" : type)}
                    </div>
                    {(isAgent ||
                      isSuper ||
                      data.source == "External" ||
                      (isExists &&
                        data.source == "STRIVE" &&
                        (data.status == "Proposal" ||
                          data.status == "Property Info"))) && (
                      <div>
                        {" "}
                        {edit ? (
                          <button
                            className="button-new negative margin-left"
                            onClick={handleCancel}
                             disabled={isAgentRestrictedUser || isOriginalDataEmpty || data.status_code === "Inactive"}
                             style={{ opacity: (isAgentRestrictedUser || isOriginalDataEmpty) ? 0.5 : 1,}}
                          >
                            {viewMode &&( data.arcimedes_row_id || data.id)
                              ? data && (data.deleted === 1 || data.status_code === "Inactive")
                                ? "Undelete"
                                : "Delete"
                              : "Cancel"}
                          </button>
                        ) : (
                          <LinkComp
                            to={backLink}
                            style={{
                              opacity:(isOriginalDataEmpty || isAgentRestrictedUser)
                                  ? 0.5
                                  : 1,
                              pointerEvents:
                              (isOriginalDataEmpty || isAgentRestrictedUser)
                                  ? "none"
                                  : "auto",
                              cursor:
                               (isOriginalDataEmpty || isAgentRestrictedUser)
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <button
                              disabled={(isOriginalDataEmpty || isAgentRestrictedUser)}
                              className="button-new negative margin-left"
                            >
                              Cancel
                            </button>
                          </LinkComp>
                        )}
                        <button
                          form={`${type}-form`}
                          type="submit"
                             style={{ opacity: (isOriginalDataEmpty || isAgentRestrictedUser) ? 0.5 : 1,}}
                          disabled={(isOriginalDataEmpty || isAgentRestrictedUser) ||
                            isAgent ||
                            data.deleted === 1 ||
                            (!edit &&
                              isSeniorAgent &&
                              ((data.source == "External" &&
                                !(
                                  data.status == "Active" ||
                                  data.status == "Closed"
                                )) ||
                                (data.source == "STRIVE" &&
                                  !(data.status == "Proposal"))))
                          }
                          className={`button-new positive  margin-left ${
                            data.deleted === 1 ? "inactive" : ""
                          }`}
                        >
                          {edit ? (viewMode ? "Edit" : "Save") : "Add"}
                        </button>
                        {(edit && backName) && (
                          <button
                            style={{
                              marginLeft: "18px",
                               opacity: (isOriginalDataEmpty || isAgentRestrictedUser) ? 0.5 : 1,
                            }}
                            className={`button-new positive  margin-left ${
                              data.deleted === 1 ? "inactive" : ""
                            }`}
                            onClick={() => {
                              setOpenEmailPopup(true)
                            }}

                            disabled={
                              data.deleted === 1  ||  (isOriginalDataEmpty || isAgentRestrictedUser)
                            }
                          >
                            Mail
                          </button>
                        )}
                      </div>
                    )}
                    {extraHeaderInfo}
                    {/* {state.searchCrudFilter && <div style={{ display: 'flex', gap: '25px', marginLeft: '50px', marginTop: "8px", color: "rgb(144, 197, 75)" }}>
                      <ArrowBackIosIcon style={{ cursor: state.currentIndex === 0 ? "not-allowed" : "pointer" }}  disabled={currentIndex === 0} onClick={prevRecord} />
                      <ArrowForwardIosIcon style={{ cursor: state.currentIndex === state.filterData.length - 1 ? "not-allowed" : "pointer" }}  disabled={currentIndex === filterData.length - 1} onClick={nextRecord} />
                    </div>} */}
                  </div>
                </div>
              </div>
              <div
                className={`page-body-container crud ${
                  type === "property" ? "property" : ""
                }`}
              >
                {success ? <Alert type="success">{success}</Alert> : null}
                {error ? <Alert type="error">{error}</Alert> : null}
                {errorTabs.length > 0 && currentTab !== 0 ? (
                  <Alert type="error">
                    Unable to add {type} because you have an empty mandatory
                    field on another tab.
                  </Alert>
                ) : null}

                <form onSubmit={handleSubmit} id={`${type}-form`} className={`form-container ${isAgent ? "isAgent" : ""}`} >
                  <Tabs
                    currentTab={state.currentTab}
                    onChangeTab={(tab) => {
                      if (
                        tabsData[tab].name.indexOf("PROPERTY") >= 0 &&
                        tabsData[tab].renderedComponent &&
                        tabsData[tab].renderedComponent.props.data &&
                        tabsData[tab].renderedComponent.props.data
                          .arcimedes_row_id
                      ) {
                        router &&
                          router.push(
                            "/property/" +
                              tabsData[tab].renderedComponent.props.data
                                .arcimedes_row_id
                          );
                      }
                      setState({ currentTab: tab });
                    }}
                    errorTabs={errorTabs}
                    tabsData={tabsData}
                    className={tabsClass}
                  />
                </form>
                {openEmailPopup &&
                <EmailPopover openEmailPopup={openEmailPopup} setOpenEmailPopup = {setOpenEmailPopup}/>
                }
                {extraInfo && (
                  <div className="CRUD_content_extra_info">
                    <div className="line" />
                    {extraInfo}
                  </div>
                )}
              </div>
            </div>
            {children}
          </div>
        );
    }
};

export default CRUD;
